<template>
  <div class="mdl-grid mdl-grid--no-spacing line-gauge-container">
    <div class="mdl-cell mdl-cell--middle lg-label mdl-typography--body-1 typography--color-secondary">
      {{ label }}
    </div>

    <div class="mdl-cell mdl-cell--middle lg-box">
      <LineGauge v-bind:value="value" v-bind:bg-color="bgColor"></LineGauge>
    </div>
  
    <div class="mdl-cell mdl-cell--middle lg-position-num mdl-typography--body-1 typography--color-secondary">
      {{ value }}{{ unit }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'basic-line-gauge',

    props: {
      value: {
        type: Number,
        default: 50,
      },
      unit: {
        type: String,
        default: '',
      },
      label: {
        type: String,
      },
      bgColor: {
        type: String,
        default: '#00c896',
      },
    },
  };
</script>

<style lang="scss">
  .line-gauge-container {
    position: relative;
    height: 18px;

    .lg-label {
      width: 30%;
      line-height: 18px;
    }

    .lg-box {
      width: 57%;
    }

    .lg-position-num {
      width: 13%;
      line-height: 18px;
      text-align: right;
      font-weight: 500;
    }

    .line-gauge {
      margin: 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// BasicLineGauge.vue?83cc0492